/* ==========================================================================
   MD3 MOTION — scroll-reveal entrances (HIG "elegant motion")
   Sections fade-rise once as they enter the viewport. Fully progressive:
   content is visible by default; this script adds the hiding class only to
   elements still below the initial viewport, so no-JS visitors, reduced-
   motion users, the theme editor, and Section-Rendering-API re-renders
   (collection grid, PDP gallery — deliberately untargeted) never see hidden
   content. Styles live in md3-hig.css (.md3-reveal / .md3-reveal-in).
   ========================================================================== */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var targets = document.querySelectorAll('.sk-section, .sk-ba, .sk-trust');
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('md3-reveal-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  targets.forEach(function (el) {
    // Only elements below the fold ever get hidden — above-fold content
    // stays painted exactly as server-rendered.
    if (el.getBoundingClientRect().top <= window.innerHeight * 0.9) return;
    el.classList.add('md3-reveal');
    observer.observe(el);
  });
})();
